import React from 'react';
import Footer from '../../components/Footer';
import Header from '../../components/Header';
import ApplicationMain from './ApplicationMain';

const MembershipApplication = () => {
  return (
    <div>
      <>
        <Header />

        <ApplicationMain />

        <Footer />
      </>
    </div>
  );
};
export default MembershipApplication;
